import { render, staticRenderFns } from "./odemetab.vue?vue&type=template&id=68389d94"
import script from "./odemetab.vue?vue&type=script&lang=js"
export * from "./odemetab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports